document.addEventListener('click', (e) => {
  try {
    if (!window.SC_AUTH) {
      const a = e.target.closest('a[href*="/pages/dealer-price-list"]');
      if (a) {
        e.preventDefault();
        location.href = '/account/login?return_to=' + encodeURIComponent(location.href);
      }
    }
  } catch(_){}
});
